import { Theme } from "@mui/material";

export const getScheduleTableHeaderStyles = (theme: Theme) => ({
  bgcolor: theme.palette.mode === "dark" ? "grey.800" : "grey.100",
});

export const getScheduleTableHeaderCellStyles = (theme: Theme) => ({
  fontWeight: 600,
  borderBottom: "1px solid",
  borderBottomColor: theme.palette.mode === "dark" ? "grey.600" : "grey.400",
  py: 1,
  color: theme.palette.mode === "dark" ? "text.primary" : "text.primary",
});

export const getClickableRowStyles = () => ({
  cursor: "pointer",
  "&:hover": {
    opacity: 0.9,
    bgcolor: "action.hover",
  },
});

export const getScheduleTableRowBaseStyles = (theme: Theme) => ({
  borderBottom: "1px solid",
  borderBottomColor: theme.palette.mode === "dark" ? "grey.700" : "divider",
  "& > td": {
    py: 1.5,
  },
});
